var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"newsletter"},[_c('div',{staticClass:"col",domProps:{"innerHTML":_vm._s(_vm.content)},on:{"click":_vm.open}})])}
var staticRenderFns = []

export { render, staticRenderFns }